import './Hero.css.proxy.js';
/* src/components/Hero.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_style,
	space,
	text,
	toggle_class
} from "../web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let hero;
	let div0;
	let em;
	let p0;
	let t0;
	let t1;
	let div1;
	let p1;
	let span0;
	let t2;
	let t3;
	let div2;
	let h1;
	let t4;
	let span1;
	let t5;
	let t6;
	let div3;
	let p2;
	let t7;
	let mounted;
	let dispose;

	return {
		c() {
			hero = element("hero");
			div0 = element("div");
			em = element("em");
			p0 = element("p");
			t0 = text("hello");
			t1 = space();
			div1 = element("div");
			p1 = element("p");
			span0 = element("span");
			t2 = text("&");
			t3 = space();
			div2 = element("div");
			h1 = element("h1");
			t4 = text("welcome");
			span1 = element("span");
			t5 = text(",");
			t6 = space();
			div3 = element("div");
			p2 = element("p");
			t7 = text("partner!");
			this.h();
		},
		l(nodes) {
			hero = claim_element(nodes, "HERO", { class: true });
			var hero_nodes = children(hero);
			div0 = claim_element(hero_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			em = claim_element(div0_nodes, "EM", {});
			var em_nodes = children(em);
			p0 = claim_element(em_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "hello");
			p0_nodes.forEach(detach);
			em_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t1 = claim_space(hero_nodes);
			div1 = claim_element(hero_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			p1 = claim_element(div1_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			span0 = claim_element(p1_nodes, "SPAN", { style: true });
			var span0_nodes = children(span0);
			t2 = claim_text(span0_nodes, "&");
			span0_nodes.forEach(detach);
			p1_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			t3 = claim_space(hero_nodes);
			div2 = claim_element(hero_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			h1 = claim_element(div2_nodes, "H1", { class: true });
			var h1_nodes = children(h1);
			t4 = claim_text(h1_nodes, "welcome");
			span1 = claim_element(h1_nodes, "SPAN", { style: true });
			var span1_nodes = children(span1);
			t5 = claim_text(span1_nodes, ",");
			span1_nodes.forEach(detach);
			h1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			t6 = claim_space(hero_nodes);
			div3 = claim_element(hero_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			p2 = claim_element(div3_nodes, "P", { class: true });
			var p2_nodes = children(p2);
			t7 = claim_text(p2_nodes, "partner!");
			p2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			hero_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p0, "class", "svelte-13u91zs");
			attr(div0, "class", "sub svelte-13u91zs");
			set_style(span0, "color", "rgb(255,255,170)");
			set_style(span0, "text-shadow", "1px 2px 2px rgba(0,0,0,0.2)");
			set_style(span0, "font-weight", "300");
			attr(p1, "class", "svelte-13u91zs");
			attr(div1, "class", "sub svelte-13u91zs");
			set_style(span1, "color", "rgb(255,255,170)");
			set_style(span1, "font-size", "2.8rem");
			set_style(span1, "text-shadow", "1px 2px 2px rgba(0,0,0,0.3)");
			set_style(span1, "font-weight", "300");
			attr(h1, "class", "svelte-13u91zs");
			attr(div2, "class", "title svelte-13u91zs");
			attr(p2, "class", "svelte-13u91zs");
			attr(div3, "class", "sub svelte-13u91zs");
			attr(hero, "class", "svelte-13u91zs");
			toggle_class(hero, "hover", /*hover*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, hero, anchor);
			append(hero, div0);
			append(div0, em);
			append(em, p0);
			append(p0, t0);
			append(hero, t1);
			append(hero, div1);
			append(div1, p1);
			append(p1, span0);
			append(span0, t2);
			append(hero, t3);
			append(hero, div2);
			append(div2, h1);
			append(h1, t4);
			append(h1, span1);
			append(span1, t5);
			append(hero, t6);
			append(hero, div3);
			append(div3, p2);
			append(p2, t7);

			if (!mounted) {
				dispose = [
					listen(hero, "mouseenter", /*enter*/ ctx[1]),
					listen(hero, "mouseleave", /*leave*/ ctx[2])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*hover*/ 1) {
				toggle_class(hero, "hover", /*hover*/ ctx[0]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(hero);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { title } = $$props;
	let { hover = false } = $$props;

	function enter() {
		$$invalidate(0, hover = true);
	}

	function leave() {
		$$invalidate(0, hover = false);
	}

	$$self.$$set = $$props => {
		if ("title" in $$props) $$invalidate(3, title = $$props.title);
		if ("hover" in $$props) $$invalidate(0, hover = $$props.hover);
	};

	return [hover, enter, leave, title];
}

class Hero extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { title: 3, hover: 0, enter: 1, leave: 2 });
	}

	get enter() {
		return this.$$.ctx[1];
	}

	get leave() {
		return this.$$.ctx[2];
	}
}

export default Hero;
//# sourceMappingURL=Hero.js.map
